import Vue from 'vue'
import Router from 'vue-router'
import Home from './../views/home'
import Login from './../views/login'
import MyPub from './../views/myPub'
import MyAccept from './../views/myAccept'
import Index from './../views/index'
import Help from './../views/help'
import User from './../views/user'
import UserInfo from './../views/userInfo'
import Auth from './../views/auth'
import Finance from './../views/finance'
import Protocol from './../views/protocol'
import Qa from './../views/qa'
import Information from './../views/information'
import Notice from './../views/notice'
import Details from './../views/details'
import SignUp from './../views/sign-up'
import MySignUp from './../views/my-sign-up'
import Examination from './../views/examination'
import examSearch from './../views/exam-search'
import certificateSearch from './../views/certificate-search'
import examResult from './../views/exam-result'
import Operation from './../views/operation'
import Address from './../views/address'




Vue.use(Router)

const router= new Router({
  //mode:'history',
  routes: [
    {path: '/', redirect:'/home'},
    {path: '/index', name: 'Index',component: Index},
    {path: '/home', name: 'home',component: Home},
    {path: '/login', name: 'login',component: Login},
    {path: '/myPub', name: 'myPub',component: MyPub},
    {path: '/help', name: 'help',component: Help},
    {path: '/myAccept', name: 'myAccept',component: MyAccept},
    {path: '/protocol', name: 'protocol',component: Protocol},
    {path: '/examination', name: 'examination',component: Examination},
    {path: '/exam-search', name: 'examSearch',component: examSearch},
    {path: '/certificate-search', name: 'certificateSearch',component: certificateSearch},
    {path: '/operation', name: 'operation',component: Operation},
    {path: '/details/:id', name: 'details',component: Details},
    {path: '/notice', name: 'notice',component:Notice },
    {path: '/information', name: 'information',component: Information},
    {path: '/qa', name: 'qa',component: Qa},
    {path: '/auth', name: 'auth',component: Auth},
    {path: '/sign-up', name: 'signUp',component: SignUp},
    {path: '/my-sign-up', name: 'mySignUp',component: MySignUp},
    {path: '/exam-result', name: 'examResult',component: examResult},
    {path: '/address', name: 'address',component: Address},
    {path: '/user', name: 'user', component: User,
      children: [  //这里就是二级路由的配置
        {
          path: '/userInfo',
          name: 'userInfo',
          component: UserInfo
        },
        {
          path: '/finance',
          name: 'finance',
          component: Finance
        }
      ]
    }
  ]
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由  
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
  let data=Vue.prototype.common.GetlocalStorage("UnLockUserData");
  let path = to.path;
  if (path === '/login') {
    next()
    return
  }
  if (data) {
      Vue.prototype.store.dispatch('showActions',JSON.parse(data).NickName);
      next();
  } else {
    Vue.prototype.store.dispatch('hideActions');
    if(to.name=="home" || to.name=="mhome" || to.name=="protocol" || to.name=="information" || to.name=="notice" || to.name=="details"){
      next();
    }
    else{
      next({
        path: '/login'
      })
    }
  }
});


export default router;





// WEBPACK FOOTER //
// ./src/router/index.js